import React from 'react'

export default class Angle extends React.Component {
  componentWillMount() {
    const { paths, color, map, setCurrentIfApplicable, distance, cameraMarkerPosition, horizontalAngleOfView, model,
      showCameraBlindspot, addToMarkers, activeInUI, selectionOverride, showAnalyticZones, showCameraComponents, showWallBlindspots } = this.props
    this.polygon = new google.maps.Polygon({
      strokeColor: color,
      strokeOpacity: 0.8,
      strokeWeight: showWallBlindspots ? 2 : 3,
      fillColor: color,
      fillOpacity: ((showCameraBlindspot && horizontalAngleOfView < 180) || showAnalyticZones || showWallBlindspots) ? 0 : 0.55,
      zIndex: (activeInUI || selectionOverride) ? 105 : 103,
      paths: this.getPaths(paths),
      visible: horizontalAngleOfView !== 360 && showCameraComponents,
      map: map
    })

    this.circle = new google.maps.Circle({
      center: cameraMarkerPosition,
      radius: distance,
      strokeColor: color,
      strokeOpacity: 0.8,
      strokeWeight: showWallBlindspots ? 2 : 3,
      fillColor: color,
      fillOpacity: showAnalyticZones || showWallBlindspots ? 0 : 0.55,
      visible: horizontalAngleOfView === 360 && showCameraComponents,
      map: map,
      zIndex: (activeInUI || selectionOverride) ? 105 : 103,
    })

    this.PTZcircle = new google.maps.Circle({
      center: cameraMarkerPosition,
      radius: google.maps.geometry.spherical.computeDistanceBetween(paths.cameraMarkerPosition, paths.leftPosition),
      strokeColor: color,
      strokeOpacity: 0.8,
      strokeWeight: 2,
      visible: model.formFactor === 'PTZ' && showCameraComponents,
      fillOpacity: 0.25,
      fillColor: activeInUI || selectionOverride ? '#555' : '#888',
      map: map
    })

    addToMarkers('polygon', this.polygon)
    addToMarkers('circle', this.circle)
    addToMarkers('PTZcircle', this.PTZcircle)

    this.polygon.addListener('click', setCurrentIfApplicable)
    this.circle.addListener('click', setCurrentIfApplicable)
    this.PTZcircle.addListener('click', setCurrentIfApplicable)
    this.polygon.addListener('mousemove', this.handleMousemove.bind(this))
    this.polygon.addListener('mouseout', this.handleMouseout.bind(this))
    this.circle.addListener('mousemove', this.handleMousemove.bind(this))
    this.circle.addListener('mouseout', this.handleMouseout.bind(this))
  }

  handleMousemove(event) {
    const { activeInUI, updatePPFHoverAction } = this.props
    if (!activeInUI) return
    updatePPFHoverAction(event.latLng)
  }

  handleMouseout() {
    const { activeInUI, updatePPFHoverAction } = this.props
    if (!activeInUI) return
    updatePPFHoverAction()
  }

  shouldPolygonBeVisible = props => props.horizontalAngleOfView !== 360 && props.showCameraComponents
  shouldCircleBeVisible = props => props.horizontalAngleOfView === 360 && props.showCameraComponents
  shouldPTZCircleBeVisible = props => props.model && props.model.formFactor === 'PTZ' && props.showCameraComponents

  componentWillReceiveProps({ paths, color, horizontalAngleOfView, distance, cameraMarkerPosition, model, showCameraBlindspot, activeInUI, selectionOverride, showAnalyticZones, showCameraComponents, showWallBlindspots }) {
    if (color !== this.props.color) {
      this.polygon.setOptions({ strokeColor: color, fillColor: color })
      this.circle.setOptions({ fillColor: color, strokeColor: color })
      this.PTZcircle.setOptions({ strokeColor: color })
    }

    if (paths !== this.props.paths) this.polygon.setPath(this.getPaths(paths))

    if (activeInUI !== this.props.activeInUI || selectionOverride !== this.props.selectionOverride) {
      this.polygon.setOptions({ zIndex: (activeInUI || selectionOverride) ? 105 : 103 })
      this.circle.setOptions({ zIndex: (activeInUI || selectionOverride) ? 105 : 103 })
      this.PTZcircle.setOptions({ fillColor: activeInUI || selectionOverride ? '#555' : '#888' })
    }

    if (cameraMarkerPosition !== this.props.cameraMarkerPosition) {
      this.circle.setCenter(cameraMarkerPosition)
      this.PTZcircle.setCenter(cameraMarkerPosition)
    }

    if (distance !== this.props.distance) {
      this.circle.setRadius(distance)
      this.PTZcircle.setRadius(google.maps.geometry.spherical.computeDistanceBetween(paths.cameraMarkerPosition, paths.leftPosition))
    }

    if (horizontalAngleOfView !== this.props.horizontalAngleOfView) this.PTZcircle.setRadius(google.maps.geometry.spherical.computeDistanceBetween(paths.cameraMarkerPosition, paths.leftPosition))

    if (this.props.showCameraBlindspot !== showCameraBlindspot ||
      (this.props.horizontalAngleOfView < 180 && horizontalAngleOfView >= 180) ||
      (this.props.horizontalAngleOfView >= 180 && horizontalAngleOfView < 180)) {
      this.polygon.setOptions({
        fillColor: color,
        fillOpacity: showAnalyticZones || showWallBlindspots || (showCameraBlindspot && horizontalAngleOfView < 180) ? 0 : 0.55
      })
    }

    if (this.props.showAnalyticZones !== showAnalyticZones || this.props.showWallBlindspots !== showWallBlindspots) {
      this.polygon.setOptions({
        fillColor: color,
        fillOpacity: showAnalyticZones || showWallBlindspots || (showCameraBlindspot && horizontalAngleOfView < 180) ? 0 : 0.55,
        strokeWeight: showWallBlindspots ? 2 : 3
      })
      this.circle.setOptions({
        fillColor: color,
        fillOpacity: showAnalyticZones || showWallBlindspots ? 0 : 0.55,
        strokeWeight: showWallBlindspots ? 2 : 3
      })
    }

    if (showCameraComponents !== this.props.showCameraComponents || horizontalAngleOfView !== this.props.horizontalAngleOfView || model.formFactor !== this.props.model.formFactor) {
      this.polygon.setVisible(this.shouldPolygonBeVisible({ horizontalAngleOfView, showCameraComponents }))
      this.circle.setVisible(this.shouldCircleBeVisible({ horizontalAngleOfView, showCameraComponents }))
      this.PTZcircle.setVisible(this.shouldPTZCircleBeVisible({ model, showCameraComponents }))
    }
  }

  getPaths(paths) {
    if (paths.halfCircle) {
      return paths.halfCircle
    } else if (paths.endAngle) {
      return paths.endAngle
    } else {
      const { cameraMarkerPosition, leftPosition, rightPosition } = paths
      return [...Object.values({ cameraMarkerPosition, leftPosition, rightPosition })]
    }
  }

  shouldComponentUpdate() {
    return false
  }

  render() {
    return null
  }
}



// WEBPACK FOOTER //
// ./src/components/Camera/Angle.js